import { render, staticRenderFns } from "./BeBasketInfo.vue?vue&type=template&id=33ed5d80&scoped=true"
import script from "./BeBasketInfo.vue?vue&type=script&lang=js"
export * from "./BeBasketInfo.vue?vue&type=script&lang=js"
import style0 from "./BeBasketInfo.vue?vue&type=style&index=0&id=33ed5d80&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ed5d80",
  null
  
)

export default component.exports